module.exports = __webpack_public_path__ + "67e631df8205221ca064d3a004a46823.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/arrow_down.svg
// module id = 503
// module chunks = 0